// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608120734/js/" + chunkId + "." + {"44":"ed3f2ca5","225":"2cd73460","481":"bba87e08","486":"29e1d685","770":"19b01078"}[chunkId] + ".0.15803671588612944.chunk.js";
};